import { brand } from "@/constants/brandVariables/brandVariables";
import { Flex, Heading } from "@radix-ui/themes";
import { FC, JSX, ReactNode } from "react";

type SamsungHeaderProps = {
  /** Headline lines, each rendered as a brand gradient heading. */
  lines: string[];
  /** Optional supporting copy shown beneath the headline. */
  subtitle?: ReactNode;
  /** Optional content pinned to the right (e.g. the countdown timer chip). */
  rightSlot?: ReactNode;
};

// Shared logo + headline block used across the Samsung Racing screens
// (leaderboard, countdown, endscreen) so spacing stays consistent.
const SamsungHeader: FC<SamsungHeaderProps> = ({
  lines,
  subtitle,
  rightSlot,
}): JSX.Element => (
  <Flex justify="between" align="start">
    <Flex direction="column" gap="4">
      <img src={brand.brandLogo} alt="" width={200} />

      <Flex direction="column" className="sr-headline-group">
        {lines.map((line) => (
          <Heading
            key={line}
            as="h2"
            size="9"
            weight="bold"
            className="gradient sr-headline"
          >
            {line}
          </Heading>
        ))}
      </Flex>

      {subtitle}
    </Flex>

    {rightSlot}
  </Flex>
);

export default SamsungHeader;
